import Vue from "vue";
import store from "../../store";

Vue.filter("capitalize", function(value) {
  if (!value) {
    return '';
  }
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("removeDecimalIfNotNecessary", function(value) {
  if (typeof value === 'string') {
    value = parseFloat(value);
  }

  if(Math.round(value) === value) {
    return Math.round(value);
  }
  return value;
});

Vue.filter("localDate", function(date, shortMonth = false) {
  let locale = window.navigator.userLanguage || window.navigator.language || "en-GB";
  let options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  if (shortMonth) {
    options.month = 'short';
    locale = store.getters["auth/language"] || locale;
  }

  if (typeof date === 'object') {
    date = date.toLocaleDateString(locale, options);
  } else if (typeof date === 'string') {
    let dateParts = date.split("/");
    date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    date = date.toLocaleDateString(locale, options);
  }

  return date;
});
